"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.invariant = void 0;
function invariant(condition, format, ...args) {
    if (typeof format !== 'string') {
        throw new Error('invariant requires an error message argument');
    }
    if (!condition) {
        let argIndex = 0;
        const error = new Error(format.replace(/%s/g, () => args[argIndex++]));
        error.name = 'Invariant Violation';
        throw error;
    }
}
exports.invariant = invariant;
//# sourceMappingURL=invariant.js.map